import React from 'react';

import { twMerge } from 'tailwind-merge';

import { Spinner } from '@components/common/Spinner';

export const PDFLoadingFallback: React.FC<{ className?: string }> = ({ className }) => (
  <div className={twMerge('flex flex-1 items-center justify-center rounded-lg bg-white p-8', className)}>
    <div className='flex flex-col items-center space-y-4'>
      <Spinner className='h-10 w-10' />
      <p className='text-sm text-gray-600'>Loading PDF...</p>
    </div>
  </div>
);
